// Team data for Franchise India Knowledge Services

const A = "https://customer-assets.emergentagent.com/job_franchise-asia/artifacts";

export const leadership = [
  {
    name: "Gaurav Marya",
    role: "Chairman",
    initials: "GM",
    photo: `${A}/qgvefk0k_Gaurav%20Marya.jpeg`,
    bio: "A pioneering force in the franchising industry and a leading voice for entrepreneurship, championing knowledge-based businesses worldwide.",
  },
  {
    name: "Satyam Garg",
    role: "Managing Director",
    initials: "SG",
    photo: `${A}/sea3yypx_Satyam%20Garg.jpeg`,
    bio: "Drives the vision and growth strategy, partnering with world-class brands to make them franchise-ready and scale them across new markets.",
  },
  {
    name: "Manasi Chauhan",
    role: "Head, Marketing",
    initials: "MC",
    photo: `${A}/gtfiqscp_Manasi%20Chauhan.jpeg`,
    bio: "Leads brand and marketing strategy, shaping how the world's finest knowledge brands are positioned and grown across markets.",
  },
];

export const team = [
  { name: "Akansha Jha", role: "Brand Services Manager", initials: "AJ", photo: `${A}/0fx6xr3n_Akansha%20Jha.jpeg` },
  { name: "Mohd Anas", role: "Manager - International Business Development", initials: "MA", photo: `${A}/9fxro7cy_WhatsApp%20Image%202026-07-07%20at%202.59.10%20PM.jpeg` },
  { name: "Mayuri", role: "Brand Service Manager", initials: "MY", photo: `${A}/3aon3365_Mayuri%20K.jpeg` },
  { name: "Shobhit Yadav", role: "Head - Global Franchise Associate", initials: "SY", photo: "/team_photos/shobhit.png" },
  { name: "Manisha Patani", role: "General Manager - Brand Servicing", initials: "MP", photo: `${A}/lzhmlta5_Manisha%20Patni.jpeg` },
  { name: "Sneha", role: "Brand Service Manager", initials: "SN", photo: `${A}/g8yrsgow_Sneha%20K.jpeg` },
  { name: "Sanjana Mathews", role: "Brand Service Manager", initials: "SM", photo: "/team_photos/sanjana.png" },
  { name: "Anjali Singh", role: "Manager - Channel Partner", initials: "AS", photo: `${A}/tvh1fge8_Anjali%20Singh.webp` },
  { name: "Manish Kumar", role: "Partner Onboarding Manager", initials: "MK", photo: "/team_photos/manish.png" },
  { name: "Prabhakar Jha", role: "MIS Executive", initials: "PJ", photo: `${A}/fmrtiuf8_Prabhkar%20Jha.jpeg` },
];

// Distinct accent colors cycled across avatars (from brand prism)
export const avatarColors = [
  "#D90429", "#F5B700", "#0081A7", "#059669", "#7C3AED", "#EA580C",
];
